import ShopPremiumContent from './ShopPremiumContent';
export default ShopPremiumContent;
